import { render, staticRenderFns } from "./WaveformCanvas.vue?vue&type=template&id=247532c0&scoped=true&"
import script from "./WaveformCanvas.vue?vue&type=script&lang=js&"
export * from "./WaveformCanvas.vue?vue&type=script&lang=js&"
import style0 from "./WaveformCanvas.vue?vue&type=style&index=0&id=247532c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247532c0",
  null
  
)

export default component.exports